import { z } from "zod";

import dayjs from "dayjs";

/**
 * ReportTreinamentoFuncionario
 */

export const ReportTreinamentoFuncionarioSchema = z.object({
  dataRealizacao: z.coerce.string().transform((x): Date => dayjs(x, 'YYYYMMDD').toDate()),
  instrutor: z.string(),
  local: z.string(),
  conteudoProgramatico: z.coerce.number(),
  assinatura: z.coerce.number().nullable().default(null),
});

/**
 * ReportTreinamentoFuncionarioForm
 */

export type ReportTreinamentoFuncionarioForm = z.infer<typeof ReportTreinamentoFuncionarioSchema>;

/**
 * defaultReportTreinamentoFuncionarioValues
 */

export const defaultReportTreinamentoFuncionarioValues: Partial<ReportTreinamentoFuncionarioForm> = {
  conteudoProgramatico: 0,
}